export enum BinaryChoice {
  Yes = "YES",
  No = "NO",
}

export namespace BinaryChoice {
  export const fromBoolean = (ifYes: boolean): BinaryChoice => {
    return ifYes ? BinaryChoice.Yes : BinaryChoice.No;
  };

  export const toBoolean = (choice: string): boolean => {
    switch (choice) {
      case BinaryChoice.Yes:
        return true;
      case BinaryChoice.No:
        return false;

      default:
        throw new Error(`"${choice}" cannot be converted to boolean`);
    }
  };

  export const toBooleanString = (choice: BinaryChoice): string => {
    switch (choice) {
      case BinaryChoice.Yes:
        return "true";
      case BinaryChoice.No:
        return "false";

      default:
        throw new Error(`"${choice}" cannot be converted`);
    }
  };
}

export const ACCUMULUS_TRUST_URL = "https://trust.accumulustechnologies.com/";

export enum DatadogCustomActions {
  EmailCaptured = "EMAIL_CAPTURED",
  AddTrackingEvent = "ADD_TRACKING_EVENT",
}

export enum DatadogCustomErrors {
  TOAST = "TOAST",
  PROJECT = "PROJECT",
}
